import React from "react";
import g from "glamorous";
import Link from "gatsby-link";
import { FaPlus } from "react-icons/fa";

const Div = g.div({
  borderRadius: `0 0 4px 4px`,
  padding: `12px`,
  backgroundColor: `white`,
  color: `#1f1f1f`,
  border: `1px solid rgba(73,105,126,0.08)`,
  boxShadow: `0 1px 7px rgba(0,0,0,.05)`,
  margin: `0 0 2em`,
  transition: `all 0.15s ease-in-out`,
});

const Title = g.div({
  margin: `0 auto .8em`,
  letterSpacing: `0.05em`,
  fontSize: `1.2em`,
  paddingBottom: `3px`,
  color: `#49697e`,
  borderBottom: `2px solid #49697e`,
  fontWeight: `bold`,
});

const Date = g.div({
  fontSize: `.7em`,
  letterSpacing: `0.05em`,
  fontWeight: `600`,
  color: `#49697e`,
  marginBottom: `-3px`,
});

const NewsTitle = g.div({
  fontSize: `.95em`,
  lineHeight: `1.4em`,
  margin: `0 0 1em`,
  color: `#1f1f1f`,
  borderBotton: `none`,
  paddingBottom: `2px`,
  ":hover": {
    textDecoration: `underline`,
  },
});

const More = g.div({
  color: `#49697e`,
  fontSize: `14px`,
  textAlign: `right`,
});

export default ({ ...props }) => (
  <Div>
    <Title>Dernières actualités</Title>

    <Date>17/08/2026</Date>
    <Link to="/consultation-en-toute-discretion/">
      <NewsTitle>
        Consultation en toute discrétion&nbsp;: une organisation sur mesure de
        votre parcours de soins
      </NewsTitle>
    </Link>

    <Date>11/08/2026</Date>
    <Link to="/visage/lifting-deep-plane/">
      <NewsTitle>Lifting deep plane du visage (Deep plane facelift)</NewsTitle>
    </Link>

    <Date>17/01/2026</Date>
    <Link to="/peau/laser-ultraclear/">
      <NewsTitle>
        UltraClear<sup>®</sup>&nbsp;: un laser innovant basé sur une technologie
        à fibre infrarouge
      </NewsTitle>
    </Link>

    <Date>10/07/2025</Date>
    <Link to="/seins/motiva-preserve/">
      <NewsTitle>
        Augmentation mammaire mini-invasive avec Motiva Preservé
      </NewsTitle>
    </Link>

    <Date>20/03/2024</Date>
    <Link to="/visage/lifting-du-cou-platysmaplastie/">
      <NewsTitle>
        Lifting du cou par platysmaplastie cutanéo-musculaire
      </NewsTitle>
    </Link>

    <Date>25/01/2023</Date>
    <Link to="/actualites/sisthaema/">
      <NewsTitle>
        Sisthaema&nbsp;: un «&nbsp;Skinbooster&nbsp;» de dernière génération,
        pour une régénération cutanée systématique et plus durable
      </NewsTitle>
    </Link>

    <Date>06/01/2023</Date>
    <Link to="/regard/plexr/">
      <NewsTitle>
        Plexr® : Traitement des paupières, des rides et des imperfections
        cutanées
      </NewsTitle>
    </Link>

    <More>
      <Link to="/actualites/" css={{ color: `#49697e` }}>
        <FaPlus
          css={{
            fontSize: `1em`,
            padding: `0 .3em 0.13em`,
            transform: `translateY(3px)`,
          }}
        />
        Toutes les actualités
      </Link>
    </More>
  </Div>
);
